import { render, staticRenderFns } from "./OurValuesShapeOne.vue?vue&type=template&id=05f41970&"
import script from "./OurValuesShapeOne.vue?vue&type=script&lang=js&"
export * from "./OurValuesShapeOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports